import React from 'react';

import SelectionModal from './abstract/modal';

function renderProperty(property) {
  return <React.Fragment>
    <strong>{property.name}</strong>
  </React.Fragment>;
}

const ContactsPropertiesSelectionModal = props => (
  <SelectionModal
    itemLabel="properties"
    queryKey="name_or_city_or_state_or_zip_or_address_cont"
    renderItem={renderProperty}
    searchPath="/research/properties.json"
    searchPlaceholder="Enter a property name or address"
    {...props}
  />
);

export default ContactsPropertiesSelectionModal;
